export default function TierLabel({ tier }) {
  const classes = `text-sm font-bold font-Play text-${tier && tier.toLowerCase()}`;
  return <span className={classes}>{tier.toUpperCase()}</span>;
}
